import React, { Component } from 'react';

import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { FormattedHTMLMessage } from 'react-intl';

import { formatMoney, getMaxMinLoanAmountValue } from '../utils/utils.js';
import apiService from '../services/apiService.js'
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner.js';
import CustomSlider from './CustomSlider.js';
import Header from './Header.js';
import LeadInfo from './LeadInfo.js';
import RenderField from './RenderField.js';
import FlowProgressBar from './FlowProgressBar.js';
import CarSimulationOfferGroup from './CarsimulationOfferGroup.js'
import CustomAlert from './CustomAlert.js';
import validate from './Validations/validationsCarSimulation.js';

import 'rc-slider/assets/index.css';
import CarSimulationOption from './CarSimulationOption.js';

require(`../assets/${process.env.PAGE}/css/custom-slider.css`);
require(`../assets/${process.env.PAGE}/css/components/CarSimulation.css`);

class CarSimulation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            leadName: '',
            maxAmount: null,
            minAmount: null,
            amountAvailables: null,
            quotes: null,
            otherOffers: null,
            isSimulated: false,
            requestError: false,
            validateDocument: false,
            hasDocument: false,
            productSelected: false,
            car: null,
        };
        this.selectProductOption = this.selectProductOption.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.hasOffers = this.hasOffers.bind(this);
    }

    async componentDidMount() {
        try {
            const { data } = await apiService.getResource('/steps/params')

            const amountAvailables = data.loan_quota_options

            const maxAmountAvailable = getMaxMinLoanAmountValue(amountAvailables, 'max')
            const minAmountAvailable = getMaxMinLoanAmountValue(amountAvailables, 'min')

            this.props.setDefaultValue({
                requested_amount: minAmountAvailable,
                capital_amount: 0,
            })

            this.setState({
                amountAvailables: amountAvailables,
                maxAmount: maxAmountAvailable,
                minAmount: minAmountAvailable
            });
        } catch (e) {
            this.setState({ requestError: true })
        }
    }

    handleBackStep = async (event) => {
        event.preventDefault()
        this.setState({
            isSimulated: this.state.productSelected ? true : false,
            productSelected: false,
            hasDocument: false,
        })
    }

    async handleNextStep(event) {
        event.preventDefault();
        const { capital_amount, loan_amount_value, document_number } = this.props
        const { hasDocument } = this.state

        if (loan_amount_value && !hasDocument) {
            const documentValidation = validate(this.props)
            let validateDocument = documentValidation.document_number || false;
            this.setState({ validateDocument })
            if (validateDocument) {
                return
            } else {
                this.setState({ hasDocument: true })
            }
        }

        await this.getQuotes(capital_amount, loan_amount_value, document_number)
    }

    async getQuotes(capital_amount, loan_amount_value, document_number) {
        try {
            this.setState({ isLoading: true });

            const data = {
                capital_amount: capital_amount || 0,
                requested_amount: loan_amount_value,
                document_number: document_number || null
            }

            const response = await apiService.postResource('/subscribers/car_simulation', data)

            const { quote } = response.data
            this.setState({
                quotes: quote.offers,
                otherOffers: quote.other_offers,
                isSimulated: true,
                isLoading: false,
                requestError: false
            })
        } catch (e) {
            this.setState({
                quotes: null,
                otherOffers: null,
                isSimulated: false,
                isLoading: false,
                requestError: true
            })
        }
    }

    selectProductOption(car_selected, offer_selected) {
        this.props.dispatch(change(this.props.form, 'car_selected', car_selected));
        this.props.dispatch(change(this.props.form, 'offer_selected', offer_selected));
        this.setState({ productSelected: true, car: car_selected });
    }

    hasOffers(quotes) {
        return Object.values(quotes).some((offers) => offers.length > 0);
    }

    render() {
        const { handleSubmit, loan_amount_value, clientName } = this.props;

        const { maxAmount, minAmount, amountAvailables, isSimulated, quotes, validateDocument, requestError, hasDocument, otherOffers } = this.state;

        const selectedAmount = formatMoney(loan_amount_value, 0, ',', '.');

        const minAmountAvailable = formatMoney(minAmount, 0, ',', '.', false);

        const maxAmountAvailable = formatMoney(maxAmount, 0, ',', '.', false);

        const requestErrorObj = { title: '¡Lo sentimos!', message: 'Ocurrió un problema al obtener la información de las ofertas disponibles. Volvé a intentarlo dentro de unos minutos.' }

        const orderedOffersName = quotes && Object.keys(quotes).sort((a, b) => (a === 'ofertas' ? 1 : b === 'ofertas' ? -1 : 0));

        const dni_field = <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className={validateDocument ? "form-group has-error" : "form-group"}>
                    <span> Elige el valor de cuotas que se ajuste <b>a tu economía y te mostramos</b> las opciones mas adecuadas para ti.</span>
                    <Field className="form-control" name="document_number" autoComplete="off" component={RenderField} type={'number'} label="Ingresá tu DNI" />
                    {((validateDocument && <div className="help-block"><span>{`${validateDocument}`}</span></div>))}
                </div>
            </div>
        </div>

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                        <FormattedHTMLMessage id="app.step_car_simulation" description="Product info" values={{ nameClient: clientName, }} />
                        {isSimulated && <h4 className="car-simulation-title">Seleccioná la opción de financiación que más se adecua a vos:</h4>}
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <form onSubmit={handleSubmit} className={`pvc-form  ${isSimulated ? 'hidden' : ''}`}>
                                {(this.props.isLoading || this.state.isLoading) && <CustomSpinner message='Estamos buscando tu auto ideal' />}
                                {requestError && <CustomAlert bsStyle="info" title={requestErrorObj.title} message={requestErrorObj.message} />}
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="form-group">
                                            <Field className="form-control" name="capital_amount" autoComplete="off" component={RenderField} type="currency" label="Ingresá tu capital a invertir" />
                                        </div>
                                    </div>
                                </div>
                                <Field name="requested_amount"
                                    label={<h4>Valor de las cuotas</h4>}
                                    component={CustomSlider}
                                    productList={amountAvailables && amountAvailables}
                                    initialValue={loan_amount_value}
                                    minAmountAvailable={minAmountAvailable}
                                    maxAmountAvailable={maxAmountAvailable}
                                    selectedAmount={selectedAmount}
                                />
                                {(loan_amount_value && !hasDocument) ? dni_field : null}
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={false} onClick={this.handleNextStep}>{isSimulated ? 'Buscar nuevamente' : 'Buscar Oportunidad'}</button>
                                    </div>
                                </div>
                            </form>
                            {isSimulated && (
                                this.hasOffers(quotes) ? (
                                    <div>
                                        {!this.state.productSelected && orderedOffersName.map((offerName) => {
                                            const offerGroup = quotes[offerName];
                                            if (offerGroup.length > 0) {
                                                return (
                                                    <CarSimulationOfferGroup
                                                        key={offerName}
                                                        selectProductOption={this.selectProductOption}
                                                        offerName={offerName}
                                                        offers={offerGroup}
                                                    />
                                                );
                                            }
                                            return null;
                                        })}
                                        {this.state.productSelected &&
                                            <div>
                                                <CarSimulationOption
                                                    disabled={false}
                                                    car={this.state.car}
                                                    expanded={true}
                                                    finished={
                                                        <div>
                                                            <button
                                                                className="btn btn-warning btn-lg pd-button pd-form"
                                                                disabled={false}
                                                                onClick={handleSubmit(this.props.addCar)}
                                                            >
                                                                Finalizar
                                                            </button>
                                                            <div className="text-left">
                                                                <button type="button" onClick={this.handleBackStep} className="btn btn-warning btn-lg pd-custom-button pd-form back">Volver</button>
                                                            </div>
                                                        </div>
                                                    }
                                                />

                                            </div>
                                        }
                                        {!this.state.productSelected &&
                                            <div className="text-left">
                                                <button type="button" onClick={this.handleBackStep} className="btn btn-warning btn-lg pd-custom-button pd-form pd-fixed-button back">Volver</button>
                                            </div>
                                        }
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                            <h3>No tenemos una opción disponible para vos</h3>
                                        </div>
                                        <div className="text-left">
                                            <button type="button" onClick={this.handleBackStep} className="btn btn-warning btn-lg pd-custom-button pd-form back pd-fixed-button">Volver</button>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}


const selector = formValueSelector('CarSimulation')

CarSimulation = connect(
    state => {
        const loan_amount_value = selector(state, 'requested_amount')
        const capital_amount = selector(state, 'capital_amount')
        const document_number = selector(state, 'document_number')
        const car_selected = selector(state, 'car_selected')
        const offer_selected = selector(state, 'offer_selected')
        return {
            loan_amount_value,
            capital_amount,
            document_number,
            car_selected,
            offer_selected
        }
    }
)(CarSimulation)

CarSimulation = TopScrolleable(CarSimulation);

CarSimulation = reduxForm({
    form: 'CarSimulation', // a unique name for this form
})(CarSimulation);

CarSimulation = LeadInfo(CarSimulation);

CarSimulation = withAuthControl(CarSimulation);

export default CarSimulation;



/** WEBPACK FOOTER **
 ** ./src/components/CarSimulation.js
 **/